import { Component, OnInit, OnDestroy, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AnimalsTableService } from 'src/app/modules/acbcr/common/services/animals-table.service';

@Component({
  selector: 'app-arbore-genealogic',
  templateUrl: './arbore-genealogic.component.html',
  styleUrls: ['./arbore-genealogic.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class ArboreGenealogicComponent implements OnInit, OnDestroy, AfterViewInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  matricol: string;
  htmlContent: string;

  constructor(
    private route: ActivatedRoute,
    private animalsTableService: AnimalsTableService,
  ) {}

  ngOnInit() {
    this.route.params
      .pipe(distinctUntilChanged((prev, curr) => prev['matricol'] === curr['matricol']))
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.htmlContent = '';
        this.matricol = params['matricol'];
        let req_params = {
          matricol: this.matricol,
        };

        this.animalsTableService
          .arboreGenealogicAPI(req_params)
          .subscribe({
            next: (response: any) => {
              this.htmlContent = response;
            }
          });
      });
  }

  ngAfterViewInit() {
    document.body.style.padding = '0';
    document.body.style.overflow = 'auto';
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
